import { Component } from '@angular/core';
import { DeliverableAnalyticsContentDirective } from '../../deliverable-analytics-content.directive';
import { SocialPostDetailsComponent } from '../social-post-details/social-post-details.component';

@Component({
  imports: [SocialPostDetailsComponent],
  selector: 'app-x-post-details',
  templateUrl: './x-post-details.component.html',
})
export class XPostDetailsComponent extends DeliverableAnalyticsContentDirective {}
